import getStore from '../store/store';
import { mutatorAction } from 'satcheljs';
import { calendarEvent } from 'owa-calendar-services/lib/utils/calendarEvent';
export default mutatorAction('updateCalendarViewItems', function (items) {
    var optionState = getStore().currentState;
    optionState.calendarViewItems = [];
    if (items) {
        items.forEach(function (item) {
            if (!item.IsCancelled) {
                optionState.calendarViewItems.push(calendarEvent(item));
            }
        });
    }
});
//# sourceMappingURL=updateCalendarViewItems.js.map